import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-works',
  templateUrl: './works.component.html',
  styles: [
  ]
})
export class WorksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
